import { memo } from "react";

import { MapPinIcon } from "./icons";

/**
 * AccessSection: アクセスセクション（住所 + 地図プレースホルダ）
 * ゲスト側 app/frontend/guest/_shared/src/components/facility-info/AccessSection.astro の逐語再現。
 * プレビュー用途のため Google Maps iframe は読み込まず、灰色プレースホルダで代用する。
 */

type Props = {
	addressText?: string;
};

export const AccessSection = memo(({ addressText = "京都府 京都市 ●●区 ●●町 1-2-3" }: Props) => {
	return (
		<div>
			<h3 className="mb-5 text-xl font-semibold text-zinc-800">アクセス</h3>
			<div className="mb-2 flex items-center gap-1">
				<MapPinIcon size={20} className="shrink-0 text-zinc-800" />
				<p className="text-sm text-zinc-800">{addressText}</p>
			</div>
			<div className="flex h-[200px] items-center justify-center overflow-hidden rounded-lg bg-zinc-100 text-sm text-zinc-400">
				地図プレビュー
			</div>
		</div>
	);
});

AccessSection.displayName = "AccessSection";
